<template>
  <div class="home">
    <header>
      <router-link to="/">
        <img src="@/assets/merheje-logo.svg" alt="Merheje Logo" height="40" />
      </router-link>
      <router-link to="/donde-encontrarnos" class="header-link">
        <img :src="dondeIcon" alt="Donde Encontrarnos" class="donde-icon" />
      </router-link>
    </header>
    <HomeSections />
  </div>
</template>

<script setup>
// @ is an alias to /src
import HomeSections from "@/components/HomeSections.vue";
import dondeIcon from "@/assets/dondeencontrarnos.svg";
</script>

<style scoped>
.home {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
header {
  position: fixed;
  top: 0;
  width: 100%;
  height: 5rem;
  padding: 0.5rem 2rem;
  box-sizing: border-box;
  background: linear-gradient(
    180deg,
    #00000070 0%,
    #00000035 35%,
    #00000000 80%
  );
  display: flex;
  justify-content: space-between;
  align-items: center;
}
header > a > img:not(.donde-icon) {
  height: 4rem;
  filter: brightness(100%) invert(100%);
}

.donde-icon {
  height: 2.5rem;
  object-fit: contain;
}
.header-link {
  color: white;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.1rem;
  transition: opacity 0.2s ease;
}
.header-link:hover {
  opacity: 0.8;
}

/* Responsive Design */
@media (max-width: 768px) {
  header {
    height: 4rem;
    padding: 0.25rem 1rem;
  }

  header > a > img:not(.donde-icon) {
    height: 3rem;
  }

  .donde-icon {
    height: 1.8rem;
  }

  .header-link {
    font-size: 0.9rem;
  }
}
</style>
